import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { useCoalitionSpaceAnalytics } from "./coalition-space_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./coalition-space_partner_config";

const Theme = lazyWithRetry(() => import("./coalition-space_theme"));

const faqs = [
  {
    question: "What are your hours?",
    answer:
      "Day pass users will have access to the buildings during business hours Monday through Friday 9AM to 5PM.",
  },

  {
    question: "How fast is your Internet speed?",
    answer:
      "We provide premium high-speed fiber internet in all of our Coalition Space locations. We also offer the option to opt for a premium port to members who are always working online.",
  },

  {
    question: "Where are shared spaces located?",
    answer:
      "Our shared work spaces are located in the open, brightly lit west side space, located near the break room, kitchen, small conference room, etc.",
  },

  {
    question: "Can I bring dogs or other animals?",
    answer:
      "We have different policies for our different locations regarding animals in the workplace. Our Flatiron location is Dog-Friendly!",
  },
];

export function OfferingCoalitionSpaceDayPass() {
  useCoalitionSpaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description:
            "Come spend the day with us in the historic Flatiron district! Whether you need a serious place to work or need to get out of the house, our space offers a collaborative environment for you.",
          testimonials: testimonials,
          faqs: faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
